import classnames from 'classnames';
import React, { ChangeEvent } from 'react';

import { ErrorMessages } from 'common/components/Form/ErrorMessages';

import styles from './styles.module.scss';

type Props = {
  errors?: string[];
  label?: string;
  name?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  value: boolean;
};

const Checkbox = ({ errors, label, name, onChange, value }: Props) => {
  return (
    <div className={styles.checkboxContainer}>
      <div className={styles.checkboxLabel}>
        <input
          checked={value}
          className={classnames(styles.checkboxInput, {
            [styles.checkboxInputError]: !!errors
          })}
          name={name}
          onChange={onChange}
          type="checkbox"
        />
        {label ? <div dangerouslySetInnerHTML={{ __html: label }}></div> : null}
      </div>
      {errors ? (
        <ErrorMessages
          messages={errors}
          className={classnames('input-error-message', styles.checkboxError)}
        />
      ) : null}
    </div>
  );
};

export default Checkbox;
